import React, { Fragment, useState } from 'react';
import Button from '../../../Button';
import Modal from '../../../common/Modal';
import Form from './form';
import { ToastContainer } from 'react-toastify';
import Dropdown from 'react-bootstrap/Dropdown';

const Reprint = ({ isLink, orderPackageId, defaultValue }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <Fragment>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Reprint"
        headerText="Reprint Item"
      >
        <Form closeModal={closeModal} defaultValue={defaultValue} />
      </Modal>

      <Button onClick={openModal}>Reprint Item</Button>
    </Fragment>
  )
}

export default Reprint;
